import React from 'react';
import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-md p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Personvern</h1>
        
        <div className="space-y-6 text-gray-600">
          <p>
            NHO Transport vil benytte registreringer i denne appen som dokumentasjon i foreningens dialog 
            med media og myndigheter. Alle registreringer er derfor verdifulle bidrag til dette arbeidet.
          </p>
          
          <p>
            Vi tar personvern på alvor og behandler all informasjon i henhold til gjeldende lover og regler.
            Registreringene blir kun brukt til statistiske formål og for å dokumentere aktivitet.
          </p>
          
          <p>
            Har du spørsmål om hvordan vi behandler personopplysninger, ta gjerne kontakt med oss.
          </p>
        </div>

        <div className="mt-8">
          <Link
            to="/login"
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            ← Tilbake til innlogging
          </Link>
        </div>
      </div>
    </div>
  );
}